export const homeFaqs = [
  {
    question: "瓜乐圈主要更新哪些内容？",
    answer: "我们围绕福利吃瓜这个主题，固定更新名场面、爆笑高能、小甜瓜和乐子合集四大栏目。名场面负责回顾高光时刻，爆笑高能主打笑点密集的片段，小甜瓜走轻甜路线，乐子合集则按周打包轻松清单。",
  },
  {
    question: "内容多久更新一次？",
    answer: "每个栏目每天都会补充新的内容，乐子合集固定在每周五更新一期完整清单。你可以在首页的更新播报里看到当天的更新条目数量。",
  },
  {
    question: "适合什么时候看？",
    answer: "很多读者习惯在通勤、午休和睡前刷一刷，因为单篇内容大多能在三到五分钟读完，不需要连续追更，随手点开就能接住快乐。",
  },
  {
    question: "可以投稿或推荐乐子吗？",
    answer: "可以。如果你想推荐某个值得收录的名场面或乐子，直接发邮件到 hello@gualequan.com，说明大致内容即可，编辑会统一整理评估。",
  },
];

export const allFaqs = [
  ...homeFaqs,
  {
    question: "站内内容是否都是原创？",
    answer: "站内的文字整理、栏目结构和要点速览均为编辑原创撰写，内容以回顾和点评为主。若涉及具体作品画面，我们会注明来源并在收到合理反馈后及时处理。",
  },
  {
    question: "如何收藏我喜欢的内容？",
    answer: "目前可以通过浏览器书签保存文章链接，把喜欢的名场面或乐子合集单独收好。我们也在规划更顺手的收藏方式，会在后续更新中逐步补上。",
  },
  {
    question: "为什么有的文章标注了要点速览？",
    answer: "要点速览是为了照顾碎片时间阅读，用三句话先把内容讲清楚，你可以快速判断是否值得细看，再决定要不要往下读正文。",
  },
  {
    question: "瓜乐圈会做付费内容吗？",
    answer: "目前站内所有内容都是免费阅读的，不设置付费墙。如果未来出现需要说明的商业合作，我们会在文章内明确标注，保持内容透明。",
  },
];